import moment from "moment";
import { range } from "lodash";

export const THIS_YEAR = moment().month() === 0 ? moment().year() - 1 : moment().year();

export const YEAR_OPTIONS = range(2019, THIS_YEAR + 2).map((i) => ({
  label: i,
  value: i,
}));
